export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-volume-2bba1d661334142671a9480317faaf8c.svg";